import { ref } from "vue";

const highlightEventBus = ref(new Map());

export const useHighlightRow = () => {
  const highlight = (payload) => {
    const listeners = highlightEventBus.value.get(payload.type);
    listeners?.forEach((callback) => callback(payload));
  };

  const listen = (type, callback) => {
    if (!highlightEventBus.value.has(type)) {
      highlightEventBus.value.set(type, new Set());
    }
    highlightEventBus.value.get(type)?.add(callback);
  };

  const remove = (type, callback) => {
    highlightEventBus.value.get(type)?.delete(callback);
  };

  return {
    highlight,
    listen,
    remove,
  };
};
